<div class="dropdown profile-element navbar-dropdown-container">
  <ng-container *ngIf="userDetailsInDropdown">
    <shared-ui-buttons-dropdown-menu-button [buttonOptions]="buttonOptions" [customToggle]="true" class="apply-cursor-pointer">
      <shared-ui-profile-picture dropdownToggle [size]="'48px'" [pictureFullPath]="imageUrl"></shared-ui-profile-picture>
    </shared-ui-buttons-dropdown-menu-button>
  </ng-container>
  <ng-container *ngIf="!userDetailsInDropdown"
    ><span>
      <shared-ui-profile-picture [size]="'48px'" [pictureFullPath]="imageUrl"></shared-ui-profile-picture>
    </span>
    <div class="apply-cursor-pointer">
      <span class="block m-t-xs text-white">
        <strong class="font-bold text-overflow no-padding" [title]="heading">{{ heading | truncate: 20 }}</strong>
      </span>
      <span class="clear d-flex">
        <span class="text-xs block apply-subheading-color">
          <span>{{ subheading | truncate: 20 }}</span>
        </span>
        <shared-ui-buttons-dropdown-menu-button
          [buttonOptions]="buttonOptions"
          [icon]="IconType.ArrowDown"
          [type]="ButtonType.DefaultText"
          styleClass="bg-transparent small-button"
          appendTo=".navbar-dropdown-container"
          iconSize="0.8rem"
        >
        </shared-ui-buttons-dropdown-menu-button>
      </span>
    </div>
    <div class="logo-element">
      <shared-ui-profile-picture [size]="'30px'" [pictureFullPath]="imageUrl"></shared-ui-profile-picture>
    </div>
  </ng-container>
</div>
<ng-template #headingAndSubheading>
  <span class="block m-t-xs">
    <strong class="font-bold text-overflow no-padding" [title]="heading">{{ heading | truncate: 20 }}</strong>
  </span>
  <span class="clear">
    <span class="text-xs font-bold block apply-subheading-color">
      <span>{{ subheading | truncate: 20 }}</span>
    </span>
  </span>
</ng-template>
